module.exports = __webpack_public_path__ + "static/pew-global-religion-ca67258d59b01d786c035fe6fe1bdca2.png";